export const API_LIMIT = {
  DEFAULT_LIMIT: 50,
} as const;

export const API_PAGE = {
  DEFAULT_PAGE: 1,
} as const;

export const API_SORT_ORDER = {
  ASCENDING: 'asc',
  DESCENDING: 'desc',
} as const;

export const API_SORT_BY = {
  NAME: 'name',
  CREATED_AT: 'created_at',
} as const;
